import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'gender',
  standalone: false,
})
export class GenderPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: number): unknown {
    let genders = ['Male', 'Female'];
    return this.translateService.instant('text.' + genders[value - 1]);
  }
}
